import IndexFooter from "../IndexFooter";

const Footer = ({ theme, footerWavePath }) => {
  return (
    <section>
      {!!footerWavePath && (
        <img className="w-full" src={footerWavePath} alt="wave" />
      )}
      <IndexFooter
        isLightMode={!theme.isDark}
        footerBackground={theme.footer.backgroundColor}
      />
    </section>
  );
};

export default Footer;
